import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InitProtocolManagerState, ProtocolManagerState, ProtocolManagerStateModel } from '@app/evaluation/components/protocol-manager/protocol-manager.state';
import {CustomProtocol, CustomProtocolService, Filter, FilterQueryMode, ProtocolFilter, Sample, SampleService} from '@core/data';
import { Snackbar } from '@core/material';
import { Protocol } from '@library';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface OrganizationGroupProtocolFilterFormDialogData {
    orgKey: string;
    groupKey: string;
    groupType: string;
}

export interface OrganizationGroupProtocolFilterFormDialogResult {
    protocolKey: string;
}

@Component({
    selector: 'pv-organization-group-protocol-filter-form-dialog',
    templateUrl: 'organization-group-protocol-filter-form.dialog.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrganizationGroupProtocolFilterFormDialog implements OnInit {
    @Select(ProtocolManagerState)
    protocolState$: Observable<ProtocolManagerStateModel>;

    @Select(ProtocolManagerState.protocolOptions)
    protocolOptions$: Observable<Protocol[]>;

    _protocolKeyControl: FormControl = new FormControl('', [Validators.required]);

    formGroup = new FormGroup({
        protocolKey: this._protocolKeyControl,
    });

    selectedProtocol: Protocol;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: OrganizationGroupProtocolFilterFormDialogData,
        private _dialog: MatDialogRef<OrganizationGroupProtocolFilterFormDialog>,
        private _snackbar: Snackbar,
        private _store: Store,
    ) { }

    ngOnInit() {
        let protocolFilter: Partial<ProtocolFilter> = { baseProtocols: false, sampleTypes: [this.data.groupType] };
        this._store.dispatch(new InitProtocolManagerState(this.data.orgKey, true, protocolFilter));
    }

    attempt() {
        this.formGroup.updateValueAndValidity();
        if (this.formGroup.valid) this.submit();
        else this._snackbar.error("Check your input and try again.");
    }

    submit() {
        this._dialog.close(this.formGroup.value);
    }

    cancel() {
        this._dialog.close();
    }
}
